import React, { useState, HtmlHTMLAttributes } from 'react'
import { BsImage } from 'react-icons/bs';
import { SiRocket } from "react-icons/si";
import { FaBrush, FaDownload, FaFilePdf } from 'react-icons/fa6';
import { TbCircleDashedNumber7, TbFileTypeXls } from "react-icons/tb";
import { IoIosSave } from "react-icons/io";
import { PiTextAaBold, PiTShirt } from "react-icons/pi";
import { BiLogOut, BiSolidUserCircle } from "react-icons/bi";
import LoaderSVG from './iconSvgs/loader';
import { FaUsers } from "react-icons/fa";
import { GrDocumentDownload, GrClear } from "react-icons/gr";
import {
    IoIosList, IoIosMail, IoIosMailUnread, IoIosEyeOff, IoIosEye, IoMdArrowDropdown, IoMdRefreshCircle,
    IoIosStar, IoIosStarHalf, IoIosStarOutline, IoIosSend
} from "react-icons/io";
import {
    MdGridView, MdOutlineStore, MdNavigateNext, MdOutlineLocationOn, MdKeyboardArrowDown, MdOutlineAdd,
    MdOutlineFileUpload, MdInfoOutline, MdRefresh, MdClose
} from "react-icons/md";
import { FaPlus, FaRegFile, FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { TbAdjustments, TbList, TbPencil } from "react-icons/tb";
import Tooltip from './tooltip';


export type iconNames = 'jersey' | 'brush' | 'text' | 'number' | 'image' | 'rocket' | 'loader'
    | 'download' | 'download-file' | 'save' | 'logout' | 'plus'
    | 'user' | 'users' | 'clear' | 'pdf' | 'xls' | 'next' | 'list' | 'grid' | 'email' | 'eye'
    | 'eye-off' | 'store' | 'location' | 'arrow-down' | 'arrow-dropdown' | 'add' | 'file-upload' | 'file'
    | 'info' | 'refresh' | 'advance-filter' | 'close' | 'chevron-up' | 'chevron-down' | 'full-star' | 'half-star'
    | 'star' | 'list' | 'send' | 'edit' | 'loader';

interface props extends HtmlHTMLAttributes<HTMLDivElement> {
    name: iconNames;
    size?: any;
    className?: string;
    onClick?: (e: any) => void
    tooltipText?: string;
    width?: string;
}

const Icon: React.FC<props> = ({
    children,
    name,
    size = '24',
    className = '',
    onClick,
    tooltipText,
    width,
    ...args
}) => {
    const [isActive, setIsActive] = useState(false);
    
    const getIconByName = (name: iconNames): JSX.Element | null => {
        switch (name) {
            case 'jersey': return <PiTShirt style={{ fontSize: `${size}px` }} />;
            case 'brush': return <FaBrush style={{ fontSize: `${size}px` }} />;
            case 'text': return <PiTextAaBold style={{ fontSize: `${size}px` }} />;
            case 'number': return <TbCircleDashedNumber7 style={{ fontSize: `${size}px` }} />;
            case 'image': return <BsImage style={{ fontSize: `${size}px` }} />;
            case 'rocket': return <SiRocket style={{ fontSize: `${size}px` }} />;
            case 'download': return <FaDownload style={{ fontSize: `${size}px` }} />;
            case 'save': return <IoIosSave style={{ fontSize: `${size}px` }} />;
            case 'logout': return <BiLogOut style={{ fontSize: `${size}px` }} />;
            case 'plus': return <FaPlus style={{ fontSize: `${size}px` }} />;
            case 'user': return <BiSolidUserCircle style={{ fontSize: `${size}px` }} />;
            case 'users': return <FaUsers style={{ fontSize: `${size}px` }} />;
            case 'download-file': return <GrDocumentDownload style={{ fontSize: `${size}px` }} />;
            case 'clear': return <GrClear style={{ fontSize: `${size}px` }} />;
            case 'pdf': return <FaFilePdf style={{ fontSize: `${size}px` }} />;
            case 'xls': return <TbFileTypeXls style={{ fontSize: `${size}px` }} />;
            case 'next': return <MdNavigateNext style={{ fontSize: `${size}px` }} />;
            case 'list': return <IoIosList style={{ fontSize: `${size}px` }} />;
            case 'grid': return <MdGridView style={{ fontSize: `${size}px` }} />;
            case 'email': return <IoIosMail style={{ fontSize: `${size}px` }} />;
            case 'eye': return <IoIosEye style={{ fontSize: `${size}px` }} />;
            case 'eye-off': return <IoIosEyeOff style={{ fontSize: `${size}px` }} />;
            case 'store': return <MdOutlineStore style={{ fontSize: `${size}px` }} />;
            case 'location': return <MdOutlineLocationOn style={{ fontSize: `${size}px` }} />;
            case 'arrow-down': return <MdKeyboardArrowDown style={{ fontSize: `${size}px` }} />;
            case 'arrow-dropdown': return <IoMdArrowDropdown style={{ fontSize: `${size}px` }} />;
            case 'add': return <MdOutlineAdd style={{ fontSize: `${size}px` }} />;
            case 'file-upload': return <MdOutlineFileUpload style={{ fontSize: `${size}px` }} />;
            case 'file': return <FaRegFile style={{ fontSize: `${size}px` }} />;
            case 'info': return <MdInfoOutline style={{ fontSize: `${size}px` }} />;
            case 'refresh': return <MdRefresh style={{ fontSize: `${size}px` }} />;
            case 'advance-filter': return <TbAdjustments style={{ fontSize: `${size}px` }} />;
            case 'close': return <MdClose style={{ fontSize: `${size}px` }} />;
            case 'chevron-up': return <FaChevronUp style={{ fontSize: `${size}px` }} />;
            case 'chevron-down': return <FaChevronDown style={{ fontSize: `${size}px` }} />;
            case 'full-star': return <IoIosStar style={{ fontSize: `${size}px` }} />;
            case 'half-star': return <IoIosStarHalf style={{ fontSize: `${size}px` }} />;
            case 'star': return <IoIosStarOutline style={{ fontSize: `${size}px` }} />;
            case 'list': return <TbList style={{ fontSize: `${size}px` }} />;
            case 'send': return <IoIosSend style={{ fontSize: `${size}px` }} />;
            case 'edit': return <TbPencil style={{ fontSize: `${size}px` }} />;
            case 'loader': return <LoaderSVG size={size} />;

            default: return null;
        }
    }

    const getStyle = () => {
        let style: any = {}
        if (onClick) {
            style.cursor = 'pointer';
        }
        return style
    }

    return (
        // <span onClick={onClick ? onClick : (e: any) => { }} className={`${className} ${(onClick) ? 'cursor-pointer' : ''}`}
        //     style={getStyle()}>
        //     {getIconByName(name)}
        // </span>
        <>
            <span
                onClick={onClick ? onClick : (e: any) => { }}
                className={`${className} ${onClick ? 'cursor-pointer' : ''}`}
                style={getStyle()}
                onMouseEnter={() => setIsActive(true)} // Show Tooltip on hover
                onMouseLeave={() => setIsActive(false)} // Hide Tooltip on mouse leave
            >
                {getIconByName(name)}
            </span>
            {isActive && (
        <Tooltip tooltipText={tooltipText || ''} width={width} />
      )}
        </>
    )
}

export default Icon;
